<template>
  <div class="overlay" :class="{'is-active': isActive}" @click="$emit('close')">
    <div class="overlay__wrapper" @click.stop :style="wrapperCustomStyle">
      <button class="overlay__close" @click="$emit('close')">
        <img src="~@/assets/images/close.svg" alt="Close icon">
      </button>
      <div class="overlay__inner">
        <slot name="content" />
      </div>

      <slot name="status" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "AppOverlay",
    props: {
      isActive: {
        type: Boolean,
        default: false
      },
      wrapperCustomStyle: {
        type: Object,
        required: false
      }
    }
  }
</script>
